import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import "@mantine/core/styles.css";

import * as Sentry from "@sentry/react";
import { StrictMode as ReactStrictMode } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";

import App from "./App.jsx";
import QueryProvider from "./lib/queries/QueryProvider.jsx";
import { persistor, store } from "./redux/store";

const sentryIsActive = import.meta.env.VITE_ENABLE_SENTRY === "ACTIVE";
const dsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryIsActive) {
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: dsn,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 1.0,
      sendDefaultPii: true,
      release: "vandapardakht-ng-frontend",
      beforeSend(event, hint) {
        const error = hint?.originalException as Record<string, string>;

        if (
          error?.name === "CanceledError" ||
          error?.name === "AbortError" ||
          error?.code === "ERR_CANCELED"
        ) {
          return null;
        }

        return event;
      },
    });
  });
}

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found. Make sure index.html has <div id='root'></div>");
}

const root = ReactDOM.createRoot(rootElement); // ✅ FIX HERE

root.render(
  <ReactStrictMode>
    <div dir="rtl">
      <BrowserRouter>
        <QueryProvider>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              {sentryIsActive ? (
                <Sentry.ErrorBoundary fallback={<div style={{ color: "darkred" }}>Something went wrong</div>}>
                  <App />
                </Sentry.ErrorBoundary>
              ) : (
                <App />
              )}
            </PersistGate>
          </Provider>
          <ToastContainer />
        </QueryProvider>
      </BrowserRouter>
    </div>
  </ReactStrictMode>,
);
